export enum OPENS {
    FORWARD,
    LEFT,
    RIGHT,
}
